import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import {LeistungProvider} from '../../providers/leistung/leistung';


import { ExpenseItemDetailPage } from '../expense-item-detail/expense-item-detail';
import { ExpenseItemCreatePage } from '../expense-item-create/expense-item-create';


/**
 * Generated class for the ExpensePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-expense',
  templateUrl: 'expense.html',
})
export class ExpensePage {
  Items = [];
  loading: any;
  mode = {create:true};
  filter = {verrechnet:"0"};

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	private rhynoApi: RhynoApiProvider,
    public loadingCtrl: LoadingController,
  	public leistungCtrl: LeistungProvider) {

    this.mode = navParams.data;

		//this.getData();

  }
  ionViewWillEnter(){
    this.getData();
  }
  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }
  getData(){
    this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

    this.rhynoApi.getExpenseItems({}).subscribe(
      data => {
      if (data.success){
        this.Items = data.data; 
        console.log(data);
      }
      this.loading.dismiss();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Expenses Search Complete')
    );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectProjectPage');
  }
  select(data){
  	this.navCtrl.push(ExpenseItemDetailPage, {create:true, data: data});
  }
  new(){
  	  	this.navCtrl.push(ExpenseItemCreatePage);

  }
}



// WEBPACK FOOTER //
// ./src/pages/expense/expense.ts